/* unplugin-vue-components disabled */import __unplugin_components_0 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-icon.vue';
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  class: "up-header"
};
const _hoisted_2 = {
  class: "left"
};
const _hoisted_3 = {
  key: 0,
  class: "logo"
};
const _hoisted_4 = {
  key: 4,
  class: "title"
};
const _hoisted_5 = {
  class: "right"
};
import { useUserStore } from '@/store/user';
export default /*#__PURE__*/_defineComponent({
  __name: 'up-header',
  props: {
    hideBack: {
      type: Boolean,
      default: false
    },
    back: null,
    close: null,
    title: null
  },

  setup(__props) {
    const props = __props;
    const userStore = useUserStore();
    const router = useRouter();

    const close = () => {
      var _props$close;

      props === null || props === void 0 ? void 0 : (_props$close = props.close) === null || _props$close === void 0 ? void 0 : _props$close.call(props);
    };

    const goBack = () => {
      if (props.back) {
        props.back();
      } else {
        router.back();
      }
    };

    return (_ctx, _cache) => {
      const _component_up_icon = __unplugin_components_0;

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [props.hideBack ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : _createCommentVNode("", true), props.hideBack ? (_openBlock(), _createBlock(_component_up_icon, {
        key: 1,
        name: "UniPass",
        width: "96px",
        height: "16px"
      })) : props.close ? (_openBlock(), _createBlock(_component_up_icon, {
        key: 2,
        name: "close",
        width: "24px",
        height: "24px",
        onClick: close
      })) : (_openBlock(), _createBlock(_component_up_icon, {
        key: 3,
        name: "back",
        onClick: goBack
      })), props.title ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [!props.title ? (_openBlock(), _createBlock(_component_up_icon, {
        key: 0,
        name: "more",
        onClick: _cache[0] || (_cache[0] = $event => _unref(userStore).showHeaderMore = !_unref(userStore).showHeaderMore)
      })) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "right")])]);
    };
  }

});